import { css, Theme } from "@emotion/react";

export const footer = (theme: Theme) =>
    css({
        backgroundColor: theme.candy.keyPalette.primaryBackgroundColor,
        borderTop: `1px solid ${theme.candy.keyPalette.primaryBackgroundColor}`,
        borderBottom: `1px solid ${theme.candy.keyPalette.primaryBackgroundColor}`,
        width: "100%",
        marginLeft: -80,
        paddingRight: 80,
        zIndex: 100,
    });

export const fixedFooter = (theme: Theme) =>
    css({
        boxShadow: `0 -3px 5px 0 ${theme.candy.legacy.shadowColor}`,
        borderLeft: `1px solid ${theme.candy.keyPalette.primaryBackgroundColor}`,
        position: "fixed",
        bottom: 0,
        left: 40,
        marginLeft: -40,
        borderCollapse: "separate",
    });

export const absoluteFooter = () =>
    css({
        position: "absolute",
    });

export const footerBorder = (theme: Theme) =>
    css({
        borderTop: theme.candy.tables.border.solid,
        borderBottom: theme.candy.tables.border.solid,
    });

export const footerContent = () =>
    css({
        paddingLeft: 40,
    });

export const absoluteFooterContent = () =>
    css({
        position: "relative",
        bottom: 0,
    });
